import {CURRENT_SETTING_CHANGED} from "./settings.types";

export const changeSetting = (setting) => {
    return {
        type: CURRENT_SETTING_CHANGED,
        payload: setting
    }
}

